import { useMutation, useQuery } from 'react-query';
import { useEffect, useRef } from 'react';

import { axios } from 'configurations/axios';
import { useSessionStore } from 'session/useSessionStore';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { SeismicAttribute } from 'features/seismic/models/interfaces/ISurveyMetadata';
import { getParamsFromUrl } from 'features/seismic/utils/seismicUrlUtils';

export function useGetSeismicAttributes(volumeToken: string|null|undefined) {
    const {tenantConfig} = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration,
    }));

    const { current: sourceApi } = useRef(getParamsFromUrl().sourceApi);

    return useQuery(['listVolumeAttributes', volumeToken], async () => {
        const response = await axios.request<IResponseAPI<SeismicAttribute[]>>({
            method: 'get',
            params: {
                volumeToken: volumeToken
            },
            url: tenantConfig?.endpoints?.attributes + '/Seismic/Attributes/All',
            headers: {
                'Content-Type': 'application/json',
                sourceApi: sourceApi,
            }
        });

        return response.data.Result;
    },{
        refetchOnWindowFocus: false,
        enabled: !!volumeToken,
        retry: 3,
    }
    );
}

export const useGetLineProducts = (projectId: number | string | undefined | null, lineName: string | undefined | null) => {
    const { jwt, host } = useSessionStore(state => ({ jwt: state.jwtToken, host: state.tenantConfiguration?.endpoints.attributes }));
    useEffect(() => { console.log('GET LINE PRODUCTS ==============>', lineName, projectId) });
    return useQuery(
        ['Attributes.AllFromLine', lineName, projectId],
        async () => {
            const response = await axios.get<IResponseAPI<SeismicAttribute[]>>(host + '/Seismic/Attributes/AllFromLine',
                {
                    params: {
                        lineName,
                        projectId
                    },
                    headers: {
                        Authorization: 'Bearer ' + jwt
                    }
                }
            );

            return response.data.Result;
        },
        {
            retry: 3,
            enabled: !!projectId && !!lineName
        }
    );
};